















































import Vue, { PropOptions } from "vue";

import PageEditContent from "@/components/bots/PageEditContent.vue";
import ButtonSave from "@/components/bots/ButtonSave.vue";
import ButtonEdit from "@/components/bots/ButtonEdit.vue";
import ButtonActive from "@/components/bots/ButtonActive.vue";
import ButtonDeactivate from "@/components/bots/ButtonDeactivate.vue";
import { Integration } from "@/models";

export default Vue.extend({
  components: {
    PageEditContent,
    ButtonSave,
    ButtonEdit,
    ButtonActive,
    ButtonDeactivate,
  },
  props: {
    bot: {
      type: Object,
    } as PropOptions<Integration>,
  },
  data() {
    return {
      editBot: {
        type: Object,
      } as PropOptions<Integration>,
    };
  },
  async mounted() {
    await this.$store.dispatch("loadBotDefaultTeam");
    await this.$store.dispatch("loadTeams");
    await this.$store.dispatch("loadUsers");
    await this.$store.dispatch("loadBotDefaultTrandingHours");

    if (
      !this.bot ||
      (this.bot && this.bot.objectId !== this.$route.params.id)
    ) {
      await this.$store.dispatch("loadBotById", this.$route.params.id);
    } else {
      await this.$store.commit("setBot", this.bot);
    }
  },
  watch: {
    "$store.state.bot.bot"(val) {
      this.editBot = val;
    },
  },
});
